import SingupContainer from '../../containers/auth/SignupContainer'

const SignupPage = () => {
  return <SingupContainer />
}
export default SignupPage
